export default {
	accountSettings: "Ustawienia",
	notificationsTitle: "Powiadomienia",
	trainingsCertificates: "Szkolenia i certyfikaty",
	activeSessions: "Sesje",

	alerts: {
		changes: "Zmiany zostały zapisane pomyślnie",
		error: "Wystąpił błąd podczas zapisywania zmian. Spróbuj ponownie",
	},

	account: {
		avatar: "Zdjęcie profilowe",
		changeAvatar: "Zmień zdjęcie profilowe",
		deleteAvatar: "Usuń zdjęcie",
		avatarInfo:
			"Waga nie powinna przekraczać 5MB. Dozwolone formaty to jpg, png, gif.",
		firstName: "Imię",
		lastName: "Nazwisko",
		editData: "Edytuj dane",
		cancel: "Anuluj",
		saveChanges: "Zapisz zmiany",
		email: "Adres e-mail",
		password: "Hasło",
		typeActualPassword: "Wprowadź aktualne hasło",
		typeNewPassword: "Ustal nowe hasło",
		passwordHint:
			"Hasło musi zawierać minimum 8 znaków, w tym przynajmniej 1 literę oraz 1 cyfrę. Dozwolone są również znaki specjalne.",
		passwordAgain: "Ponownie wpisz nowe hasło",
		savePassword: "Zapisz hasło",
		editPassword: "Zmień hasło",
		language: "Język",
	},

	notifications: {
		entries: "Wpisy",
		commentByMe: "Komentarze do opublikowanych przeze mnie wpisów",
		commentMentions: "Komentarze do opublikowanych przeze mnie wpisów",
		commentBySomeone: "Gdy ktoś skomentuje wpis, który obserwuję",
		email: "E-mail",
		desktop: "Desktop",
		mobile: "Aplikacja mobilna",
		groups: "Grupy",
		groupsNewPost: "Gdy ktoś opublikuje nowy wpis w grupie",
		groupsNewMember:
			"Gdy zostanie dodany nowy członek do grupy, w której jestem",
		tasklist: "Lista zadań",
		taskDeadline: "Gdy zbliża się termin wykonania zadania",
		taskRecieve: "Gdy zostanie przydzielone do mnie zadanie",
		actualNotifications: "Zaktualizuj ustawienia powiadomień",
	},

	trainingsAndCertificates: {
		certificates: "Zdobyte certyfikaty",
		search: "Szukaj certyfikatu",
		course: "Kurs",
		issuedBy: "Wystawione przez",
		date: "Data wystawienia",
		www: "Strona internetowa wystawcy",
		download: "Pobierz certyfikat",
		noCertificates: "Brak zdobytych certyfikatów",
	},
};
